module.exports = __webpack_public_path__ + "static/img/pic-zhou3.63ae1d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainindex/pic-zhou3.jpg
// module id = 941
// module chunks = 0